import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  computed,
  input,
} from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import {
  ShipsanRegulationLookupComponent,
  ShipsanRegulationLookupValue,
  sameShipsanSelection,
} from './shipsan-regulation-lookup.component';
import { LookupSelections, lookupList } from '../regulation-lookup-list';

@Component({
  selector: 'app-shipsan-regulation-lookup-list',
  imports: [ShipsanRegulationLookupComponent],
  templateUrl: './shipsan-regulation-lookup-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipsanRegulationLookupListComponent implements OnInit {
  readonly field =
    input.required<FieldTree<LookupSelections<ShipsanRegulationLookupValue>>>();

  protected readonly state = computed(() => this.field()());
  private readonly list = lookupList(() => this.field(), sameShipsanSelection);
  readonly entries = this.list.entries;

  ngOnInit(): void {
    this.list.seed();
  }

  addItem(): void {
    this.list.add();
  }
}
